// percent of accessibility issues found
export const accessibilityCoverage = 85
